






import Component from 'vue-class-component'
import Vue from 'vue'
import { Inject, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'

@Component({
  name: 'respondeco-form-group',
})
export default class RespondecoFormGroup extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  private readonly control!: string

  @Prop({
    type: Number,
  })
  public readonly index?: number

  @Inject()
  private readonly form!: FormGroup<any>

  public provide() {
    return {
      form: this.form.group(this.control),
    }
  }
}
